import { FC, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox, Input } from 'antd';
import { Virtuoso } from 'react-virtuoso';
import { Hint, TypeRow } from './styles';

interface IClashTypePickerProps {
  label: string;
  types: { ifcType: string; count: number }[];
  selected: string[];
  onChange(selected: string[]): void;
}

const LIST_HEIGHT = 180;

/**
 * Tipos IFC com geometria na cena, para um lado da regra personalizada. Modelo
 * grande passa das centenas de tipos, então a lista é virtualizada e tem busca.
 */
const ClashTypePicker: FC<IClashTypePickerProps> = ({ label, types, selected, onChange }) => {
  const { t } = useTranslation('federatedViewer');
  const [search, setSearch] = useState('');

  const visible = useMemo(() => {
    const term = search.trim().toLowerCase();
    return term ? types.filter((type) => type.ifcType.toLowerCase().includes(term)) : types;
  }, [types, search]);

  const toggle = (ifcType: string, checked: boolean) => onChange(checked
    ? [...selected, ifcType]
    : selected.filter((type) => type !== ifcType));

  return (
    <div>
      <label>
        {label}
        {' · '}
        {selected.length > 0 ? t('clash.typesSelected', { count: selected.length }) : t('clash.allTypes')}
      </label>
      <Input.Search
        size="small"
        allowClear
        placeholder={t('clash.searchTypes')}
        value={search}
        onChange={(event) => setSearch(event.target.value)}
      />
      {visible.length === 0 ? (
        <Hint>{t('clash.noTypes')}</Hint>
      ) : (
        <Virtuoso
          style={{ height: LIST_HEIGHT }}
          data={visible}
          itemContent={(_, type) => (
            <TypeRow>
              <Checkbox
                checked={selected.includes(type.ifcType)}
                onChange={(event) => toggle(type.ifcType, event.target.checked)}
              >
                {type.ifcType}
              </Checkbox>
              <span className="count">{type.count}</span>
            </TypeRow>
          )}
        />
      )}
    </div>
  );
};

export default ClashTypePicker;
